export const debounce = (func, wait, immediate) => {
    let timeout;
    return function() {
        const context = this,
            args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        //eslint-disable-next-line
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
export const numberPrefix = (number, size = 1) => {
    return number.toString().length < size
        ? '0'.repeat(size - 1) + number.toString()
        : number.toString();
};
export const isEmptyObject = obj => {
    return !Object.keys(obj).length;
};

export const chunkArray = (arr, chunkSize) => {
    let index = 0;
    const arrayLength = arr.length;
    const tempArray = [];

    for (index = 0; index < arrayLength; index += chunkSize) {
        const chunk = arr.slice(index, index + chunkSize);
        // Do something if you want with the group
        tempArray.push(chunk);
    }

    return tempArray;
};

export const genUUID = function() {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';

    const uuid = s.join('');
    return uuid;
};

export const genMap = (xs = [], keyField, valueField) => {
    if (keyField === void 0) keyField = 'code';
    if (valueField === void 0) valueField = 'name';

    return xs.reduce((acc, x) => {
        var obj;

        return Object.assign(
            Object.assign({}, acc),
            ((obj = {}),
            (obj[x[keyField]] = valueField === '_self' ? x : x[valueField]),
            obj)
        );
    }, {});
};
/**
 * 复制到剪切板（异步）
 * document.execCommand('copy') safari仅支持同步复制 10以下会报错
 */
export async function asyncCopyTextToClipboard(asyncFetch) {
    if (
        !window ||
        !window.navigator ||
        !window.navigator.clipboard ||
        !window.navigator.clipboard.write
    ) {
        console.warn('[asyncCopyTextToClipboard] clipboard.write not support');
        return asyncCopyTextToClipboardFallback(asyncFetch);
    }

    try {
        const clipboardItem = new ClipboardItem({
            'text/plain': asyncFetch.then(text => {
                return new Blob([text], { type: 'text/plain' });
            })
        });
        await window.navigator.clipboard.write([clipboardItem]);

        return Promise.resolve();
    } catch (e) {
        console.warn(`[asyncCopyTextToClipboard] ${e}`);
        return asyncCopyTextToClipboardFallback(asyncFetch);
    }
}
async function asyncCopyTextToClipboardFallback(asyncFetch) {
    try {
        const text = await asyncFetch;
        return fallbackCopyTextToClipboard(text);
    } catch (e) {
        return Promise.reject(e);
    }
}

/**
 * 复制到剪切板 (同步)
 * @param {String} text 
 * @returns
 */
export async function copyTextToClipboard(text) {
    if (!window || !window.navigator || !window.navigator.clipboard) {
        return fallbackCopyTextToClipboard(text);
    }

    return window.navigator.clipboard.writeText(text).catch(e => {
        console.warn(`[clipboard.writeText] ${e}`);
        return fallbackCopyTextToClipboard(text);
    });
}
function fallbackCopyTextToClipboard(text) {
    return new Promise((resolve, reject) => {
        const el = document.createElement('textarea');

        el.value = text;
        el.setAttribute('readonly', 'readonly');
        document.body.appendChild(el);
        el.focus();
        el.select();

        try {
            const isSupport = document.execCommand('copy');

            if (!isSupport) {
                throw new Error('not_support');
            }
            resolve();
        } catch (e) {
            console.warn(`[clipboard fallback] ${e}`);
            reject(e);
        } finally {
            document.body.removeChild(el);
        }
    });
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/util/index.js